import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.progress-bar {
  position: relative;

  width: 100%;
  height: 20px;

  overflow: hidden;

  background-color: var(--background-color, #eeeeee);
  border-radius: var(--border-radius, 0);
}

.progress-bar::before {
  position: absolute;
  top: 0;
  left: -200%;

  width: 200%;
  height: 100%;

  content: "";

  background: linear-gradient(
    to right,
    transparent 0%,
    var(--progress-color, #aaaaaa) 50%,
    transparent 100%
  );

  animation: scan 2s infinite alternate ease-in-out;
}

@keyframes scan {
  from {
    left: -200%;
  }

  to {
    left: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./components/progress-bar/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,gBAAgB;;EAEhB,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;;EAEX,WAAW;EACX,YAAY;;EAEZ,WAAW;;EAEX;;;;;GAKC;;EAED,iDAAiD;AACnD;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.progress-bar {\n  position: relative;\n\n  width: 100%;\n  height: 20px;\n\n  overflow: hidden;\n\n  background-color: var(--background-color, #eeeeee);\n  border-radius: var(--border-radius, 0);\n}\n\n.progress-bar::before {\n  position: absolute;\n  top: 0;\n  left: -200%;\n\n  width: 200%;\n  height: 100%;\n\n  content: \"\";\n\n  background: linear-gradient(\n    to right,\n    transparent 0%,\n    var(--progress-color, #aaaaaa) 50%,\n    transparent 100%\n  );\n\n  animation: scan 2s infinite alternate ease-in-out;\n}\n\n@keyframes scan {\n  from {\n    left: -200%;\n  }\n\n  to {\n    left: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
